import { useNavigate } from 'react-router-dom';
import Activity from '@/components/Activity';

export function ActivityPage() {
  const navigate = useNavigate();

  return <Activity onBack={() => navigate('/dashboard')} />;
}
